import { Button } from "@kontaktfix/ui";
import { ShieldCheckIcon } from "@phosphor-icons/react";
import { useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { LogoMark } from "@/components/logo";

function MicrosoftIcon() {
  return (
    <svg viewBox="0 0 21 21" className="size-4" aria-hidden>
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}

export function LoginPage() {
  const { t, i18n } = useTranslation();
  const { error } = useSearch({ from: "/login" });
  const errorKey = error
    ? i18n.exists(`login.errors.${error}`)
      ? `login.errors.${error}`
      : "login.errors.default"
    : null;

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-subtle px-4 py-10">
      <div
        className="pointer-events-none absolute inset-0 opacity-60"
        style={{
          backgroundImage: "radial-gradient(var(--color-border-strong) 1px, transparent 1px)",
          backgroundSize: "20px 20px",
          maskImage: "radial-gradient(ellipse at center, black 30%, transparent 75%)",
        }}
      />
      <div className="relative w-full max-w-[380px]">
        <div className="mb-8 flex flex-col items-center text-center">
          <LogoMark size={40} />
          <h1 className="mt-5 text-xl font-semibold tracking-tight">{t("login.title")}</h1>
          <p className="mt-1.5 text-[13.5px] text-fg-muted">{t("login.subtitle")}</p>
        </div>
        <div className="rounded-lg border border-border bg-bg p-5 shadow-md">
          {errorKey && (
            <div className="mb-4 rounded-md bg-danger-soft px-3 py-2 text-[13px] text-danger">
              {t(errorKey)}
            </div>
          )}
          <Button asChild variant="secondary" size="lg" className="w-full justify-center">
            <a href="/api/auth/login">
              <MicrosoftIcon />
              {t("login.microsoft")}
            </a>
          </Button>
        </div>
        <p className="mt-4 text-center text-[12.5px]">
          <span className="text-fg-muted">{t("login.partner")}</span>{" "}
          <a
            href="/partner/login"
            className="font-medium text-fg-muted underline-offset-4 hover:text-fg hover:underline"
          >
            {t("login.partnerSignIn")}
          </a>
          <span className="text-fg-subtle" aria-hidden>
            {" "}
            ·{" "}
          </span>
          <a
            href="/partner/register"
            className="font-medium text-fg-muted underline-offset-4 hover:text-fg hover:underline"
          >
            {t("login.partnerSignUp")}
          </a>
        </p>
        <p className="mt-6 flex items-center justify-center gap-1.5 text-[12px] text-fg-subtle">
          <ShieldCheckIcon className="size-3.5" />
          {t("login.hosted")}
        </p>
      </div>
    </div>
  );
}
